import { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import ErrorIcon from '@atlaskit/icon/glyph/editor/error';
import { token } from '@atlaskit/tokens';

import messages from './loading-failed.i18n';
import * as styles from './loading-failed.style';

export default class LoadingFailed extends PureComponent<{ addonKey: string }> {
  render() {
    const { addonKey } = this.props;
    return (
      <styles.Wrapper>
        <styles.Header>
          <ErrorIcon primaryColor={token('color.icon.danger')} label="" />
          <styles.Title>
            <FormattedMessage {...messages.connectLoadingErrorTitle} />
          </styles.Title>
        </styles.Header>
        <styles.Description>
          <FormattedMessage
            {...messages.connectLoadingErrorDescription}
            values={{ appName: addonKey }}
          />
        </styles.Description>
      </styles.Wrapper>
    );
  }
}
